import {Link} from '@chakra-ui/react';
import {
  HalitrekErrorHandler,
  isProblem,
  isProblemOfType,
} from '@synako/halitrek';
import {useCallback} from 'react';
import {Trans, useTranslation} from 'react-i18next';
import {useClientRoute} from './auth/useClientRoute';
import {routes} from 'ff-common';
import {useNavigate} from 'react-router-dom';
import {TextToastCommand} from 'ff-common/src/types/TextToastCommand';
import {useCapture} from '@/CaptureSetup';

export const useDefaultOnError = (textToast: TextToastCommand) => {
  const {t} = useTranslation();
  const {buildClientRoute} = useClientRoute();
  const navigate = useNavigate();
  const capture = useCapture();

  const onError = useCallback<HalitrekErrorHandler>(
    (error) => {
      let message = error.message;
      console.warn(message);
      capture({
        name: 'error:catch',
        props: {
          exception_message: message,
          exception_type: typeof error,
          exception_stack: error.stack?.toString(),
          platform: navigator.userAgent,
          updates_channel: 'web', // TODO ?
        },
      });
      if (isProblem(error)) {
        message = error.body.detail ?? error.body.title ?? message;
      }
      if (isProblemOfType(error, 'validation_error')) {
        const validation = (error.body as {validation?: {keyword: string}[]})
          .validation;
        if (validation?.length == 1) {
          message = t([`error.${validation[0].keyword}`, message]);
        }
      }
      //NOTE(Nathan) Le hook ne peut pour le moment pas être headless à cause du link Chakra et de l'icone
      textToast(
        <Trans
          t={t}
          components={{
            Reload: (
              <Link
                onClick={() => {
                  location.reload();
                }}
              />
            ),
            // href provoque un rechargement de la page, on utilise onClick et navigate
            Contact: (
              <Link
                onClick={() => {
                  navigate(buildClientRoute(routes.client.contacts));
                }}
              />
            ),
          }}
        >
          {t([`error.${message}`, message])}
        </Trans>,
        {duration: 4000, icon: 'alert'},
      );
    },
    [textToast, t, capture, navigate, buildClientRoute],
  );

  return onError;
};
